import radium from 'radium';

function EventErrorPage() {
	const style = {
		container: {
			margin: 'auto',
		},
		error: {
			fontWeight: '600',
		},
	};
	return (
		<div style={style.container}>
			<div style={style.error}>Diese Veranstaltung ist im Moment nicht buchbar.</div>
		</div>
	);
}

export default radium(EventErrorPage);
